import React from "react";

import { ActivityIndicator } from "react-native";

import { Container, Indicator } from "./styles";

const Spinner = () => {
	return (
		<Container>
			<Indicator>
				<ActivityIndicator size="large" />
			</Indicator>
		</Container>
	);
};

export default Spinner;
